export default __webpack_public_path__ + "static/media/aero-oximeter.e4bcf770.jpg";